// Phase 1020 — Forgot Password (public) — request a one-time reset link.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { EnvelopeSimple, ArrowLeft } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success(r.data?.message || 'If the email is registered, a reset link has been sent.');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to submit request');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-zinc-200 p-8">
        <Link to="/login" className="flex items-center gap-1 text-sm text-zinc-600 hover:text-zinc-900 mb-4" data-testid="forgot-back-login">
          <ArrowLeft size={14} /> Back to login
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <EnvelopeSimple size={24} className="text-zinc-900" />
          <h1 className="text-xl font-semibold text-zinc-900">Forgot Password</h1>
        </div>
        {sent ? (
          <div className="space-y-4">
            <p className="text-sm text-zinc-700">If <span className="font-mono">{email}</span> is registered, a password reset link has been sent. The link expires in 60 minutes and can only be used once.</p>
            <p className="text-xs text-zinc-500">Please check your inbox and spam folder.</p>
            <Link to="/login" className="inline-block px-4 h-9 leading-9 text-xs font-semibold uppercase tracking-wider bg-zinc-900 text-white hover:bg-zinc-700" data-testid="forgot-back-login-btn">Return to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-zinc-600 mb-4">Enter your account email and we'll send you a one-time reset link.</p>
            <div>
              <Label>Email address *</Label>
              <Input type="email" required autoComplete="email" value={email}
                     onChange={e => setEmail(e.target.value)}
                     className="rounded-none mt-1" data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={busy || !email} className="w-full rounded-none bg-zinc-950 hover:bg-zinc-800" data-testid="forgot-submit">
              {busy ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
